import { useMemo } from 'react';

import { useCageController_getWeightDistributions } from '@/services/hooks';

import { mapWeightDistributionsResponseToDomain } from './mappers';
import type { UseGetWeightDistributionsResult } from './weightDistribution.types';

/**
 * Weight distributions for the cage, or for the fish group named by `fishGroupId` — the cohort
 * the page is about (`fg`). Omitted means the cage, with the query key it always had.
 */
export const useGetWeightDistributions = (
    cageId: number,
    params: { from?: string; to?: string; fishGroupId?: number }
): UseGetWeightDistributionsResult => {
    const getWeightDistributionsQuery = useCageController_getWeightDistributions(cageId, params);

    const weightDistributions = useMemo(
        () =>
            mapWeightDistributionsResponseToDomain(
                getWeightDistributionsQuery.data?.data ?? { weightDistributions: [] }
            ),
        [getWeightDistributionsQuery.data?.data]
    );

    return {
        ...getWeightDistributionsQuery,
        isLoading: getWeightDistributionsQuery.isPending,
        data: weightDistributions,
    };
};
